import numeral from 'numeral';
import 'numeral/locales';

const convertCurrency = (value: number): string => {
  numeral.locale('pt-br');
  return numeral(value).format('$ 0.0,');
};

export default convertCurrency;
